import type { FC, ReactElement } from 'react';

import { FileEntityType } from '@core/types/file';
import { EntityFilesSection, type FileUploadsManager } from '@web/components/Files';

type Props = {
  /** Loaded project's ID in edit mode; null while creating a project (no ID yet). */
  projectID: string | null;
  /** Drawer-level buffered upload queue for create mode. Unused once the project has
   * an ID (edit mode mounts EntityFilesPanel, which manages its own uploads). */
  manager: FileUploadsManager;
};

/**
 * Files step content for the Project drawer. Delegates to the shared
 * `EntityFilesSection` (edit mode mounts EntityFilesPanel; create mode mounts a
 * buffered FileUploadArea) -- see that component for the dispatch behavior.
 */
export const ProjectFilesSection: FC<Props> = ({ projectID, manager }): ReactElement => (
  <EntityFilesSection entityType={FileEntityType.Project} entityId={projectID} manager={manager} />
);
